<template>
	<div :class="generalStyle">
		<div :class="accentStyle"/>
		<div class="grow px-3 py-2">
			<slot/>
		</div>
	</div>
</template>
<script setup lang="ts">
import {Color} from '@/Types/Enums/Color'
import {computed, type ComputedRef} from 'vue'

const props = defineProps<{
	color:Color,
}>()

const generalStyle:ComputedRef<string> = computed(() => {
	const base:string = 'grow flex items-stretch rounded'
	switch(props.color){
		case Color.TrueAArEII:
			return `${base} bg-true-aareii-100 text-true-aareii-800 dark:bg-true-aareii-950 dark:text-true-aareii-200`
		case Color.Red:
			return `${base} bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200`
		case Color.Orange:
			return `${base} bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-200`
		case Color.Amber:
			return `${base} bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200`
		case Color.Yellow:
			return `${base} bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-200`
		case Color.Lime:
			return `${base} bg-lime-100 text-lime-800 dark:bg-lime-950 dark:text-lime-200`
		case Color.Green:
			return `${base} bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200`
		case Color.Emerald:
			return `${base} bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200`
		case Color.Teal:
			return `${base} bg-teal-100 text-teal-800 dark:bg-teal-950 dark:text-teal-200`
		case Color.Cyan:
			return `${base} bg-cyan-100 text-cyan-800 dark:bg-cyan-950 dark:text-cyan-200`
		case Color.Sky:
			return `${base} bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-200`
		case Color.Blue:
			return `${base} bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200`
		case Color.Indigo:
			return `${base} bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-200`
		case Color.Violet:
			return `${base} bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-200`
		case Color.Purple:
			return `${base} bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200`
		case Color.Fuchsia:
			return `${base} bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-950 dark:text-fuchsia-200`
		case Color.Pink:
			return `${base} bg-pink-100 text-pink-800 dark:bg-pink-950 dark:text-pink-200`
		case Color.Rose:
			return `${base} bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-200`
		case Color.Slate:
			return `${base} bg-slate-100 text-slate-800 dark:bg-slate-950 dark:text-slate-200`
		case Color.Gray:
			return `${base} bg-gray-100 text-gray-800 dark:bg-gray-950 dark:text-gray-200`
		case Color.Zinc:
			return `${base} bg-zinc-100 text-zinc-800 dark:bg-zinc-950 dark:text-zinc-200`
		case Color.Stone:
			return `${base} bg-stone-100 text-stone-800 dark:bg-stone-950 dark:text-stone-200`
		case Color.Neutral:
		default:
			return `${base} bg-neutral-100 text-neutral-800 dark:bg-neutral-950 dark:text-neutral-200`
	}
})

const accentStyle:ComputedRef<string> = computed(() => {
	const base:string = 'w-1 rounded-l'
	switch(props.color){
		case Color.TrueAArEII:
			return `${base} bg-true-aareii-500 dark:bg-true-aareii-700`
		case Color.Red:
			return `${base} bg-red-500 dark:bg-red-700`
		case Color.Orange:
			return `${base} bg-orange-500 dark:bg-orange-700`
		case Color.Amber:
			return `${base} bg-amber-500 dark:bg-amber-700`
		case Color.Yellow:
			return `${base} bg-yellow-500 dark:bg-yellow-700`
		case Color.Lime:
			return `${base} bg-lime-500 dark:bg-lime-700`
		case Color.Green:
			return `${base} bg-green-500 dark:bg-green-700`
		case Color.Emerald:
			return `${base} bg-emerald-500 dark:bg-emerald-700`
		case Color.Teal:
			return `${base} bg-teal-500 dark:bg-teal-700`
		case Color.Cyan:
			return `${base} bg-cyan-500 dark:bg-cyan-700`
		case Color.Sky:
			return `${base} bg-sky-500 dark:bg-sky-700`
		case Color.Blue:
			return `${base} bg-blue-500 dark:bg-blue-700`
		case Color.Indigo:
			return `${base} bg-indigo-500 dark:bg-indigo-700`
		case Color.Violet:
			return `${base} bg-violet-500 dark:bg-violet-700`
		case Color.Purple:
			return `${base} bg-purple-500 dark:bg-purple-700`
		case Color.Fuchsia:
			return `${base} bg-fuchsia-500 dark:bg-fuchsia-700`
		case Color.Pink:
			return `${base} bg-pink-500 dark:bg-pink-700`
		case Color.Rose:
			return `${base} bg-rose-500 dark:bg-rose-700`
		case Color.Slate:
			return `${base} bg-slate-500 dark:bg-slate-700`
		case Color.Gray:
			return `${base} bg-gray-500 dark:bg-gray-700`
		case Color.Zinc:
			return `${base} bg-zinc-500 dark:bg-zinc-700`
		case Color.Stone:
			return `${base} bg-stone-500 dark:bg-stone-700`
		case Color.Neutral:
		default:
			return `${base} bg-neutral-500 dark:bg-neutral-700`
	}
})
</script>
